import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

// carnival_backend/middleware reads "<sessionId>&<organizationId>" from the Bearer token.
const config = (s) => ({ headers: { Authorization: `Bearer ${s.sessionId}&${s.organizationId}` } });

// Only the identity fields the server needs (never the login token / otp).
const identity = (s) => ({ userId: s.userId, role: s.role, name: s.name, email: s.email });

const post = (path, s, extra = {}) => api.post(path, { ...identity(s), ...extra }, config(s)).then((r) => r.data);

export const initCarnival = (s) => post('/carnival/init', s);
export const fetchCarnivalState = (s) => post('/carnival/state', s);
export const submitGameScore = (s, gameKey, score, time, lines) => post('/carnival/submit', s, { gameKey, score, time, lines });
export const linkCarnivalReport = (s, reportId) => post('/carnival/linkReport', s, { reportId });
export const fetchLeaderboard = (s) => post('/carnival/leaderboard', s);
